'use strict';

import debounce from 'lodash/debounce';
var endpoint = $('.suggestions-wrapper').data('url');
var minChars = 0;
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;
var activeSearchDialog = null;
var inertElements = [];
var previousSearchFocus = null;

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $(scope).closest('.site-search').find('.suggestions-wrapper');
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest('.search-mobile').length;
}

function inertBackground(dialog) {
    var current = dialog;
    var parent = current.parentElement;
    var siblings;

    inertElements = [];
    while (parent) {
        siblings = Array.prototype.slice.call(parent.children);
        siblings.forEach(function (sibling) {
            if (sibling !== current) {
                inertElements.push({
                    element: sibling,
                    inertAttribute: sibling.getAttribute('inert')
                });
                sibling.setAttribute('inert', '');
            }
        });

        if (parent === document.body) {
            break;
        }

        current = parent;
        parent = parent.parentElement;
    }
}

function restoreBackground() {
    inertElements.forEach(function (entry) {
        if (entry.inertAttribute === null) {
            entry.element.removeAttribute('inert');
        } else {
            entry.element.setAttribute('inert', entry.inertAttribute);
        }
    });
    inertElements = [];
}

function setSearchDialogOpen(isOpen, restoreFocus) {
    var $dialog;
    var $input;
    var focusTarget;

    if (isOpen) {
        $dialog = $('.site-search').first();
        if (!$dialog.length || activeSearchDialog === $dialog[0]) {
            return;
        }

        activeSearchDialog = $dialog[0];
        previousSearchFocus = document.activeElement;
        $input = $dialog.find('.js-search-input').first();
        $dialog.attr({
            role: 'dialog',
            'aria-modal': 'true',
            'aria-label': $input.attr('placeholder')
        });
        $input.attr({
            'aria-haspopup': 'dialog',
            'aria-expanded': 'true'
        });
        inertBackground(activeSearchDialog);
        return;
    }

    if (!activeSearchDialog) {
        return;
    }

    $dialog = $(activeSearchDialog);
    $dialog.removeAttr('role aria-modal aria-label');
    $dialog.find('.js-search-input').attr('aria-expanded', 'false');
    activeSearchDialog = null;
    restoreBackground();

    if (restoreFocus) {
        focusTarget = previousSearchFocus;
        if (!focusTarget || !document.documentElement.contains(focusTarget)) {
            focusTarget = $dialog.find('.js-search-input')[0];
        }
        if (focusTarget && typeof focusTarget.focus === 'function') {
            focusTarget.focus();
        }
    }
    previousSearchFocus = null;
}

function getSearchDialogFocusableElements() {
    return $(activeSearchDialog).find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [contenteditable="true"], [tabindex]:not([tabindex="-1"])').filter(':visible');
}

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals(restoreFocus) {
    $('body').removeClass('modal-open');
    $('header').siblings().attr('aria-hidden', 'false');
    $('.suggestions').removeClass('modal');
    setSearchDialogOpen(false, restoreFocus);
}

/**
 * Apply modal classes needed for mobile suggestions
 *
 * @param {Object} scope - Search input field DOM element
 */
function applyModals(scope) {
    if (isMobileSearch(scope)) {
        $('body').addClass('modal-open');
        $('header').siblings().attr('aria-hidden', 'true');
        getSuggestionsWrapper(scope).find('.suggestions').addClass('modal');
    }
    setSearchDialogOpen(true, false);
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions(restoreFocus) {
    $('input.search-field').val('');
    clearModals(restoreFocus);
    $('.search-mobile .suggestions').unbind('scroll');
    $('.suggestions-wrapper').empty();
    $('body').removeClass('cc-search-is-open');
}

/**
 * Toggle search field icon from search to close and vice-versa
 *
 * @param {string} action - Action to toggle to
 */
function toggleSuggestionsIcon(action) {
    var mobileSearchIcon = '.search-mobile button.';
    var iconSearch = 'fa-search';
    var iconSearchClose = 'fa-close';

    if (action === 'close') {
        $(mobileSearchIcon + iconSearch).removeClass(iconSearch).addClass(iconSearchClose).attr('type', 'button');
    } else {
        $(mobileSearchIcon + iconSearchClose).removeClass(iconSearchClose).addClass(iconSearch).attr('type', 'submit');
    }
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    if (($(scope).scrollTop() + $(scope).innerHeight()) >= $(scope)[0].scrollHeight) {
        $('.more-below').fadeOut();
    } else {
        $('.more-below').fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    var outerHeight;
    var $scope;
    var $suggestions;
    var top;

    if (isMobileSearch(scope)) {
        $scope = $(scope);
        top = $scope.offset().top;
        outerHeight = $scope.outerHeight();
        $suggestions = getSuggestionsWrapper(scope).find('.suggestions');
        $suggestions.css('top', top + outerHeight);

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();

    $.spinner().stop();

    if (typeof (response) !== 'object') {
        $suggestionsWrapper.append(response).show();
        $('body').addClass('cc-search-is-open');
        $('.js-search-reset-button').removeClass('d-none');
        $('.js-search-close-button').removeClass('d-none');
        positionSuggestions(this);
        applyModals(this);

        // analytics trigger for search
        $('body').trigger('search-analytics-trigger');

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        var suggestionsList = $('.suggestions .item');
        if ($(suggestionsList).length) {
            $('input.search-field').attr('aria-describedby', 'search-result-count');
        } else {
            $('input.search-field').removeAttr('aria-describedby');
        }
    } else {
        $suggestionsWrapper.hide();
        $('body').removeClass('cc-search-is-open');
        clearModals();
    }
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    if ($(scope).val().length >= minChars) {
        $.spinner().start();
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($(scope).val()),
            method: 'GET',
            success: processResponse,
            error: function () {
                $.spinner().stop();
            }
        });
    } else {
        toggleSuggestionsIcon('search');
        $('.js-search-reset-button').addClass('d-none');
        $('.js-search-close-button').addClass('d-none');
        clearModals();
        getSuggestionsWrapper(scope).empty();
        $('body').removeClass('cc-search-is-open');
    }
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    // get all li elements in the suggestions list
    var suggestionsList = $('.suggestions .item');
    if (suggestionsList.filter('.selected').length === 0) {
        suggestionsList.first().addClass('selected');
        $('input.search-field').each(function () {
            $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
        });
    } else {
        suggestionsList.each(function (index) {
            var idx = index + direction;
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).removeAttr('aria-selected');
                if (suggestionsList.eq(idx).length !== 0) {
                    suggestionsList.eq(idx).addClass('selected');
                    suggestionsList.eq(idx).attr('aria-selected', true);
                    $(this).removeProp('aria-selected');
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.eq(idx)[0].id);
                    });
                } else {
                    suggestionsList.first().addClass('selected');
                    suggestionsList.first().attr('aria-selected', true);
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
                    });
                }
                return false;
            }
            return true;
        });
    }
}

export default function () {
    $('form[name="simpleSearch"]').submit(function (e) {
        var suggestionsList = $('.suggestions .item');
        if (suggestionsList.filter('.selected').length !== 0) {
            e.preventDefault();
            suggestionsList.filter('.selected').find('a')[0].click();
        }
    });

    $('input.search-field').each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        var debounceSuggestions = debounce(getSuggestions, 300);
        $(this).on('input click', function (e) {
            debounceSuggestions(this, e);
        });

        $(this).on('keyup', function (e) {
            // Capture Down/Up Arrow Key Events
            switch (e.which) {
                case DOWN_KEY:
                    handleArrow(DIRECTION_DOWN);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                case UP_KEY:
                    handleArrow(DIRECTION_UP);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                default:
                    break;
            }
        });
    });

    $('body').on('click', function (e) {
        if (!$(e.target).closest('.site-search').length) {
            $('.suggestions').hide();
            $('body').removeClass('cc-search-is-open');
            clearModals();
        }
    });

    $(document).on('keydown.searchDialog', function (e) {
        var $focusable;
        var first;
        var last;

        if (!activeSearchDialog) {
            return;
        }

        if (e.key === 'Escape' || e.keyCode === 27) {
            e.preventDefault();
            tearDownSuggestions(true);
            return;
        }

        if (e.key !== 'Tab' && e.keyCode !== 9) {
            return;
        }

        $focusable = getSearchDialogFocusableElements();
        if (!$focusable.length) {
            e.preventDefault();
            return;
        }

        first = $focusable[0];
        last = $focusable[$focusable.length - 1];
        if (e.shiftKey && (document.activeElement === first || !activeSearchDialog.contains(document.activeElement))) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && (document.activeElement === last || !activeSearchDialog.contains(document.activeElement))) {
            e.preventDefault();
            first.focus();
        }
    });

    $(document).on('focusin.searchDialog', function (e) {
        var $focusable;

        if (activeSearchDialog && !activeSearchDialog.contains(e.target)) {
            $focusable = getSearchDialogFocusableElements();
            ($focusable.length ? $focusable[0] : activeSearchDialog).focus();
        }
    });

    $('body').on('click touchend', '.search-mobile button.fa-close', function (e) {
        e.preventDefault();
        $('.suggestions').hide();
        $('body').removeClass('cc-search-is-open');
        toggleSuggestionsIcon('search');
        tearDownSuggestions(true);
    });

    $('.site-search .js-search-reset-button').on('click', function () {
        $('.js-search-reset-button').addClass('d-none');
        $('.js-search-close-button').addClass('d-none');
        $('.js-search-input').focus();
    });

    $('.site-search .js-search-close-button').on('click', function () {
        $('.js-search-close-button').addClass('d-none');
        $('.suggestions').hide();
        $('body').removeClass('cc-search-is-open');
        clearModals(true);
    });

    // Handle clicks on obfuscated links (buttons with data-url attribute)
    $('body').on('click', '.js-obfuscated-link', function (e) {
        e.preventDefault();
        var url = $(this).attr('data-url');
        if (url) {
            window.location.href = url;
        }
    });

    const $popover = $('.js-accountSlot');
    if ($popover.length && $popover.attr('data-home') === 'false') {
        $('.js-alertBanner').find('a').each(function () {
            const $link = $(this);
            const $button = $('<button></button>');
            var linkClass = $link.attr('class') || '';

            if (!linkClass.includes('cc-btn') && !linkClass.includes('cc-link')) {
                linkClass += ' cc-link';
            }

            $button.attr({
                'type': 'button',
                'class': (linkClass + ' js-obfuscated-link').trim(),
                'data-url': $link.attr('href'),
                'aria-label': $link.attr('aria-label')
            });
            $button.html($link.html());
            $link.replaceWith($button);
        });
    }
};
